import React from 'react';
import { Box, Flex, Text } from '@tonic-one/react';

interface StepIndicatorProps {
  stepNumber: number;
  isActive: boolean;
  isCompleted: boolean;
  showConnector?: boolean;
}

const ACTIVE_COLOR = '#04CAA1';
const DISABLED_COLOR = '#5E5E5E';

const StepIndicator: React.FC<StepIndicatorProps> = ({
  stepNumber,
  isActive,
  isCompleted,
  showConnector = false,
}) => {
  const bgColor = isActive || isCompleted ? ACTIVE_COLOR : DISABLED_COLOR;
  const textColor = isActive || isCompleted ? '#1A1A1A' : '#A0A0A0';

  return (
    <Flex flexDirection="column" alignItems="center" mr="16px">
      {/* Circle */}
      <Flex
        alignItems="center"
        justifyContent="center"
        width="24px"
        height="24px"
        borderRadius="50%"
        backgroundColor={bgColor}
        flexShrink={0}
      >
        <Text fontSize="12px" fontWeight="600" color={textColor}>
          {stepNumber}
        </Text>
      </Flex>

      {/* Connector Line */}
      {showConnector && (
        <Box
          width="1px"
          flex={1}
          minHeight="24px"
          backgroundColor={DISABLED_COLOR}
          mt="4px"
        />
      )}
    </Flex>
  );
};

export default StepIndicator;
